module.exports = __webpack_public_path__ + "static/media/bitmap-p-p-1@1x.9cd0af34.png";